import z from 'zod';
import {moduleTopicSchema} from '../examModule/moduleTopicSchema';

/** Input shape for question validation/check APIs (no id, no createdAt). */
export const questionCheckInputSchema = z.object({
  moduleTopic: moduleTopicSchema,
  difficulty: z.number().int().min(1).max(5),
  questionText: z.string(),
  hint: z.string().optional(),
  options: z.array(z.string()),
  answer: z.string(),
  explanation: z.string(),
});

export type QuestionCheckInput = z.infer<typeof questionCheckInputSchema>;
